<template>
  <div class="app-container" v-loading="loading">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="header-row">
        <Title>流转记录</Title>
        <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
      </div>

      <el-timeline class="mt20">
        <el-timeline-item
          v-for="item in list"
          :key="item.id"
          :timestamp="item.createdTime"
          :type="item.result === '失败' || item.result === 2 ? 'danger' : 'primary'"
          placement="top"
        >
          <el-card shadow="never">
            <div class="flexs">
              <b>{{ item.node }}</b>
              <span class="ml10">{{ item.operatorType === 1 ? '系统' : item.operatorName }}</span>
              <el-tag class="ml10" size="mini" :type="resultTagType(item.result)">{{ resultText(item.result) }}</el-tag>
            </div>
            <div class="mt10" v-if="item.beforeStatus || item.afterStatus">
              状态变化：{{ statusText(item.beforeStatus) }} → {{ statusText(item.afterStatus) }}
            </div>
            <div class="mt10" v-if="item.content">{{ item.content }}</div>
            <div class="mt10 fail-reason" v-if="item.failReason">失败原因：{{ item.failReason }}</div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div v-if="!loading && !list.length" class="empty-tip">暂无流转记录</div>
    </el-card>
  </div>
</template>

<script>
import childFollowupApi from '@/api/cust/childFollowup'

const STATUS_MAP = { 1: '待回访', 2: '回访正常', 3: '异常已关闭', 4: '待市场核实', 5: '市场核实完成' }

export default {
  name: 'SubaccountFollowupActivities',
  props: ['rowId'],
  data() {
    return {
      loading: false,
      list: []
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      childFollowupApi.fetchActivities(this.rowId)
        .then(({ data }) => { this.list = data || [] })
        .finally(() => { this.loading = false })
    },
    statusText(v) { return STATUS_MAP[v] || (v ? v : '—') },
    resultText(v) {
      if (v === 1 || v === '成功') return '成功'
      if (v === 2 || v === '失败') return '失败'
      return v || '—'
    },
    resultTagType(v) {
      if (v === 2 || v === '失败') return 'danger'
      return 'success'
    },
    // 单条流转记录导出，复用主列表的异步导出接口，带上 followupId 只导出这一条的流转记录
    handleExport() {
      this.$router.push({ path: '/export/list', query: { code: 'EEForChildFollowup', followupId: this.rowId } })
    },
    handleBack() {
      this.$emit('handleShow', this.rowId, 'show')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fail-reason {
  color: #e73f3f;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 30px 0;
}
</style>
